<template>
	<div>
		<el-card shadow="never">
			<div>
				<el-form size="small" :inline="true" label-position="right" label-width="120px" :rules="rules" :model="formData">
					<el-form-item label="卡号" prop="carNo">
						<el-input
							size="small"
							v-model="formData.carNo"
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSave">保存</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
	</div>
</template>
<script>
import dlgForm from "@/mixin/dlgForm";

export default {
	name: "BicycleAccessCardForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				carNo: [{ required: true, message: "请输入卡号", trigger: "blur" }]
			},
		};
	},
	methods: {
		doSave() {
            const url = '';
            this._doSaveForm(this.$refs.form, url, 'PUT');
		},
	},
};
</script>
